interface Fonts {
  sourceSansPro: string;
  nunito: string;
}

export const fonts: Fonts = {
  sourceSansPro: "'source-sans-pro', sans-serif",
  nunito: "'nunito', sans-serif"
};
